import React from 'react'
import { DEALER_REPORT_DAILY_DATA_ROW } from "../../constants"
import { calculateTotalGP } from '../../utils';

const MTDRow = (props) => {
  const { data, title } = props;
  if(data) {
    return (
      <tr>
        <th colSpan="1" scope="row" style={{ whiteSpace: "nowrap" }}>{title}</th>
          {DEALER_REPORT_DAILY_DATA_ROW.map((row, index) => {
            if(data[row] > 0) {
              if(row.includes('GP')) {
                return <td key={index} style={{ fontWeight: 'normal'}}>{data[row].toLocaleString('en-CA', {
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
          style: 'currency', 
          currency: 'CAD',
        })}</td>
              } else {
                return <td key={index} style={{ fontWeight: 'normal'}}>{data[row].toLocaleString()}</td>
              }
            } else {
              return <td key={index} style={{ fontWeight: 'normal'}}>0</td>
            }
          })}
          <td style={{ fontWeight: 'normal'}}>${calculateTotalGP(data)}</td>
      </tr>
    )
  } else {
      return (
        <>
          <tr>
            <td></td>
          </tr>
        </>
      )
  }
};

export default MTDRow